﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconArrowBigDownLineFilled } from "@tabler/icons-react";

export const MotivosBajaIcon = IconArrowBigDownLineFilled;
export const MotivosBajaHelpText = '* Aquí puede ver los motivos de baja.';
export class catMotivosBaja extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "MotivosBaja";
        this.def.columns.c_category_id.defaultValue = "MotivosBaja";
        this.Title = "Motivos de Baja";
        this.Icon = MotivosBajaIcon;
        this.HelpText = MotivosBajaHelpText;
    }
}